import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Tags.module.scss'

/**
 * The `Tags`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Tags = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.tags, styles.tags]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Tags.displayName = 'Tags'

/** @type {object} */
Tags.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Tags.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Tags)
